module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARAQMAAAABo9W5AAAABlBMVEVHcExOBf+1Wz9TAAAAAXRSTlMAQObYZgAAABZJREFUCNdjYDzAwIAL///fAMd41AEAZv0SCXW89ewAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mine/center_gift_ic_add.png
// module id = NP2s
// module chunks = 1